import { AllActionsSection, PermissionEnum } from '../user-roles/types';
import permissionsTree from '../user-roles/variables';
import getPreparePermissions from './helpers/get-permissions';

const getSectionActions = () => {
  const res: AllActionsSection = {};

  const columnsData = getPreparePermissions(permissionsTree);

  Object.entries(columnsData).map(
    ([key, value]) =>
      value?.pages &&
      Object.values(value.pages)
        .filter((item) => item?.actions)
        .forEach((item) => {
          res[key as PermissionEnum] = {
            ...res[key as PermissionEnum],
            ...item?.actions,
          };
        }),
  );

  return res;
};

const sectionActions: AllActionsSection = getSectionActions();

export default sectionActions;
